import type { BridgeError, BridgeStatusCode } from "owa-nested-app-auth-types";

export default function createBridgeError(status: BridgeStatusCode, code: string, subError?: string, description?: string, properties: object = {}): BridgeError {
    return {
        status,
        code,
        subError,
        description,
        properties,
    };
}
